<template>
  <div class="TablePlain">
    <v-data-table
      dense
      :headers="headers"
      :items="dataVals"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td
          v-for="col in columns"
          :key="col.id"
          :align="align(props.item[col])"
        >
          {{ props.item[col] }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'TablePlain',

  /**
   * Elementos que recibe el componente para renderizar
   */
  props: {
    /** Cabecera de la tabla */
    headers: {
      type: Array,
      required: true
    },
    /** Contenido de la tabla */
    dataVals: {
      type: Array,
      required: true
    }
  },

  data: function () {
    return {
      rowsPerPageItems: [5, 10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]
    }
  },

  computed: {
    /**
     * Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })
      return colVals
    }
  },

  methods: {
    /**
     * Determina la alineación de la celda, si es string se alinea a la izquierda
     * para los demas casos se alinea a la derecha
     * @param  {string} val El valor a evaluar
     * @return {string}      La alineación a usar
     */
    align (val) {
      let algn = 'right'
      if (typeof val === 'string' && val[val.length - 1] !== '%') {
        algn = 'left'
      }
      return algn
    }
  }
}
</script>
